import { useTranslation } from 'react-i18next';

import logo from '@assets/logos/astropay-logo.png';
import { APImage } from '@components/atoms/APImage';
import { Spinner } from '@components/atoms/Spinner';

export const SplashScreenPage = () => {
  const { t } = useTranslation();
  return (
    <div className="min-h-screen w-full flex flex-col justify-center items-center bg-[#F3F6F6]">
      <div>
        <APImage
          img={logo}
          width={114}
          height={29}
          alt={t('AstroPayDownload.title')}
          className="mb-3"
        />
        <Spinner />
      </div>
    </div>
  );
};
